class CollectionLinksSpotlight extends HTMLElement {
  connectedCallback() {
    this.items = this.querySelectorAll('[data-hover-item]');
    this.images = this.querySelectorAll('[data-hover-image]');

    this.items.forEach((item) => {
      item.addEventListener('mouseenter', () => this._activate(item.dataset.hoverItem));
      item.addEventListener('click', () => this._activate(item.dataset.hoverItem));
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this._activate(item.dataset.hoverItem);
        }
      });
    });
  }

  _activate(index) {
    this.items.forEach((item) => {
      const isActive = item.dataset.hoverItem === index;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
    this.images.forEach((img) => {
      img.classList.toggle('is-active', img.dataset.hoverImage === index);
    });
  }
}

if (!customElements.get('collection-links-spotlight')) {
  customElements.define('collection-links-spotlight', CollectionLinksSpotlight);
}
